import { css, Interpolation, Theme } from '@emotion/react';
import { theme } from '@frontend/theme';

type ContactDetailsProps = {
  children: React.ReactNode;
  styles?: Interpolation<Theme>;
};

export const StyledCardContainer = ({ children, styles }: ContactDetailsProps) => {
  return (
    <article
      css={[
        css`
          background-color: ${theme.colors.white};
          margin-bottom: ${theme.spacing(3)};
          box-shadow: ${theme.shadows.light};
          border-radius: ${theme.borderRadius.medium};
        `,
        styles,
      ]}
    >
      {children}
    </article>
  );
};
